import { render } from "./Checkout.vue?vue&type=template&id=580d95d6"
import script from "./Checkout.vue?vue&type=script&lang=ts"
export * from "./Checkout.vue?vue&type=script&lang=ts"

import "./Checkout.vue?vue&type=style&index=0&id=580d95d6&lang=css"
script.render = render

export default script